var exports = {
  "z": "x93eb46d8--f8a9f7--root",
};

module.exports = exports;
